import aesReduxConstants from '../constants';
import mapApi from '../apis/mapApi';
import mapSetActions from './mapSetActions';
import mapViewActions from './mapViewActions';
import mapQuickSearchApi from '../apis/mapQuickSearchApi';

const mapActions = function() {
  const actions = {};
  const constants = aesReduxConstants.MAP;

  const getActionType = function(type, action, suffix) {
    const validTypes = ['BASEMAP'];
    let actionType = null;

    if (validTypes.indexOf(type) !== -1) actionType = constants[type][action];

    if (suffix && actionType !== null) actionType = `${actionType}_${suffix}`;

    return actionType;
  };

  actions.hydrateMap = function() {
    return function(dispatch, getState) {
      const { context } = getState().user;

      const type = context.inSwitchContext ? 'client' : 'user';

      dispatch({ type: constants.HYDRATE });

      dispatch(mapSetActions.getMapSets(type));
      dispatch(mapViewActions.getMapViews(type));
    };
  };

  actions.getBasemaps = function() {
    return (dispatch) => {
      const promise = mapApi.getBasemaps();

      const success = (response) => {
        const { data: basemaps } = response;

        dispatch({ type: constants.GET_BASEMAPS, basemaps });
      };

      promise.then(success);
    };
  };

  actions.setDefaultBasemap = function(basemap) {
    return function(dispatch, getState) {
      const { context } = getState().user;
      const actionType = getActionType('BASEMAP', 'SET_DEFAULT');

      const success = function() {
        dispatch({ type: getActionType('BASEMAP', 'SET_DEFAULT', 'SUCCESS'), payload: basemap });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to set default basemap';

        dispatch({ type: getActionType('BASEMAP', 'SET_DEFAULT', 'FAILURE'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapApi.setDefaultBasemap(context.clientId, context.userId, basemap.id).then(success).catch(failure);
    };
  };

  actions.storeBbox = function(bbox) {
    return {
      type: constants.STORE_BBOX,
      payload: bbox,
    };
  };

  actions.setCurrentMapSet = function(mapSet) {
    const actionType = aesReduxConstants.MAP_SET.SET_CURRENT;

    return {
      type: actionType,
      payload: mapSet,
    };
  };

  actions.storeMapState = function(state) {
    return {
      type: constants.STORE_MAP_STATE,
      payload: state,
    };
  };

  actions.openNav = function(panel) {
    if (panel === undefined) {
      return {
        type: constants.OPEN_NAV,
      };
    }
    return {
      type: constants.OPEN_NAV,
      panel,
    };
  };

  actions.closeNav = function() {
    return {
      type: constants.CLOSE_NAV,
    };
  };

  actions.quickSearchSuccess = function(results) {
    return {
      type: constants.QUICK_SEARCH.QUICK_SEARCH_SUCCESS,
      results,
    };
  };

  actions.quickSearchError = function(error) {
    return {
      type: constants.QUICK_SEARCH.QUICK_SEARCH_ERROR,
      error,
    };
  };

  actions.quickSearch = function(query) {
    return function(dispatch, getState) {
      dispatch({ type: constants.QUICK_SEARCH.QUICK_SEARCH, query });

      const { context } = getState().user;
      let promise = null;

      if (context.inSwitchContext) {
        promise = mapQuickSearchApi.search(query, context.clientId);
      } else {
        promise = mapQuickSearchApi.search(query, context.clientId, context.userId);
      }
      promise.then((response) => {
        dispatch(actions.quickSearchSuccess(response.data));
      }, (error) => {
        dispatch(actions.quickSearchError(error.response.data));
      });
    };
  };

  actions.quickSearchDropPin = function(coordinates, title) {
    return {
      type: constants.QUICK_SEARCH.PREFIX + constants.DROP_POINT,
      coordinates,
      title,
    };
  };

  actions.quickSearchSetQuery = function(query) {
    return {
      type: constants.QUICK_SEARCH.QUICK_SEARCH_SET_QUERY,
      query,
    };
  };


  actions.refreshMapSets = function() {
    return function(dispatch, getState) {
      const actionType = aesReduxConstants.MAP_SET.INVALIDATE_CACHE;

      dispatch({ type: actionType });

      const { context } = getState().user;
      const type = context.inSwitchContext ? 'client' : 'user';

      dispatch(mapSetActions.getMapSets(type));
    };
  };

  return actions;
};

export default mapActions();
